import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import VSelectPT from '@/@core/components/v-select-pt/VSelectPT.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('v-select-pt', VSelectPT)
